<template>
  <div class="box">
    <!-- 顶部大图片 -->
    <imgBigCards></imgBigCards>
    <!-- 右边内容 -->
    <div class="content-right">
      <!-- 标题 个人中心 -->
      <p class="person-title">站内通知</p>
      <!-- <icon-park type="downloadFour" theme="filled"/> -->
      <!-- 主要内容 -->
      <div class="person-main">
        <div v-if="mydata.onMessageArr.length === 0">
          <p
            style="
              line-height: 520px;
              text-align: center;
              letter-spacing: 1px;
              color: #999999;
            "
          >
            暂无通知
          </p>
        </div>
        <div class="item-Notifications" v-else>
          <el-button
            type="primary"
            :disabled="mydata.selectIdArr.length === 0"
            @click="handleBatchRead"
            >已读</el-button
          >
          <el-button
            type="danger"
            :disabled="mydata.selectIdArr.length === 0"
            @click="handleBatchdel"
            >删除</el-button
          >
          <el-table
            ref="myTable"
            :data="mydata.onMessageArr"
            style="width: 100%"
            :show-header="false"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="30" />

            <el-table-column class="content-column">
              <template #default="scope">
                <itemNotificationsCards
                  :info="scope.row"
                ></itemNotificationsCards>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!--分页 -->
        <div class="gl-pagination">
          <el-pagination
            v-model:currentPage="mydata.pageObj.currentPage"
            v-model:page-size="mydata.pageObj.pageSize"
            :total="mydata.pageObj.total"
            layout="prev, pager, next"
            pager-count="4"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
// 是否来自其他模块
let fromOtherModule = false;
// 缓存组件
import { defineComponent } from "vue";
export default defineComponent({
  name: "myNotifications",
  beforeRouteEnter(to, from, next) {
    // 如果不是来自详情页面，而是来自其他模块，那么就把fromOtherModule设置为true值
    if (from.path !== "/layout/list/notificationsDetails") {
      fromOtherModule = true;
      // console.log('来自其他模块');
    }
    next();
  },
});
</script>








<script setup>
import imgBigCards from "@/components/imgBigCards/index.vue";
import { useRouter,useRoute } from "vue-router";
// import {IconPark} from '@icon-park/vue-next/es/all';

import { reactive, computed, toRefs, onActivated, inject, ref } from "vue";

import itemNotificationsCards from "@/views/personalCenter/myNotifications/components/itemNotificationsCards/index.vue";

//引入站内信息列表接口
import {
  onMessageList,
  haveRead,
  haveDelete,
  unreadMessage,
} from "@/api/personalCenter/myNotifications/index.js";

import { ElMessage, ElMessageBox } from "element-plus";
import { useStore } from "vuex"
const store = useStore()
// import { ElMessage } from 'element-plus'
// import { ComponentSize, FormInstance, FormRules } from "element-plus";

// import {
//   Delete,
//   Download,
//   Plus,
//   ZoomIn,
//   Warning,
// } from "@element-plus/icons-vue";

// import { UploadFile } from "element-plus";

const router = useRouter();
const route = useRoute();

const mydata = reactive({
  size: "default",

  // currentPage3: "5",
  // pageSize3: "100",
  // small: false,
  // background: false,
  // disabled: false,

  circleUrl:
    "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",

  sizeList: ["small"],

  userInfo: JSON.parse(localStorage.getItem("userInfo")) ?? {}, //获取的用户信息

  /////
  pageObj: {
    currentPage: 1, // 当前页数
    pageSize: 10, // 每页条数
    total: 0, // 总的条数
  },

  onMessageArr: [], //站内信息列表

  selectIdArr: [],
  // path: "/layout/list/details1",
});

const myTable = ref(null);

onActivated(() => {
  // // 如果是来自其他模块，那么就重置数据
  // if (fromOtherModule) {
  // 如果是来自其他模块，那么就重置数据。或者，第一次进入这个页面，那么就重置数据
  if (fromOtherModule || JSON.parse(localStorage.getItem('routerRecord'))[route.path] === 1) {
    mydata.userInfo = JSON.parse(localStorage.getItem("userInfo")) ?? {}; //获取的用户信息
    /////
    mydata.pageObj = {
      currentPage: 1, // 当前页数
      pageSize: 10, // 每页条数
      total: 0, // 总的条数
    };

    mydata.onMessageArr = []; //站内信息列表

    // onMessageFn()
  }
  // 重置fromOtherModule为false值，避免fromOtherModule一直是true值，不再动态变化
  fromOtherModule = false;

  // 把原来的函数调用放到缓存组件钩子里面了，原来的函数调用注释了
  onMessageFn();
});

// 当前页数改变事件
function handleCurrentChange(val) {
  // 查询
  onMessageFn();
}

const { circleUrl, sizeList } = toRefs(mydata);

//站内信息列表接口
function onMessageFn() {
  onMessageList({
    page: String(mydata.pageObj.currentPage),
    psize: String(mydata.pageObj.pageSize),
  }).then((res) => {
    mydata.onMessageArr = res.data.list;
    // console.log(mydata.onMessageArr,"消息列表")
    // 总的条数
    mydata.pageObj.total = res.data.count;
  });
  // 未读消息
  unreadMessage().then((res) => {
   store.commit('set_unreadCount',res.data.count)
  });
}

// onMessageFn();

function handleSelectionChange(val) {
  mydata.selectIdArr = val.map((item) => {
    return item.id;
  });
  // console.log(mydata.selectIdArr);
}
//已读
function handleBatchRead() {
  // console.log(123);
  // 调用接口
  haveRead({
    ids: mydata.selectIdArr.join(","),
  }).then((res) => {
    ElMessage({
      message: res.msg,
      type: "success",
    });
    // 清除表格勾选项
    myTable.value.clearSelection();
    // 查询
    onMessageFn();
  });
}
//删除
function handleBatchdel() {
  // console.log(456);

  ElMessageBox.confirm("该操作将永久删除数据，是否确认删除?", "提示", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      // 调用接口
      haveDelete({
        ids: mydata.selectIdArr.join(","),
      }).then((res) => {
        ElMessage({
          message: res.msg,
          type: "success",
        });
        // 查询
        onMessageFn();
      });
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "已取消删除",
      });
    });
}

/////////////////////////////////////////////////////

/////////////////////////////////////////////////////

// //点击事件
// function details1Button() {
//   router.push({
//     path: "/layout/list/details1",
//   });
// }
</script>

<style scoped lang="scss">
.box {
  ////右边内容
  .content-right {
    // width: 1012px;
    // height: 784px;
    background-color: #ffffff;
    // border:1px solid rgb(0, 255, 34);
    // padding-left: 62px;
    // position: relative;
    margin-top: 16px;
    overflow: hidden;

    //标题 我的图书
    .person-title {
      font-size: 16px;
      font-weight: 700;
      color: #282828;
      letter-spacing: 1px;
      line-height: 54px;
      padding: 0px 16px;
      border-bottom: 2px solid #e4e7ed;

      // margin-bottom: 10px;
    }

    //主要内容
    .person-main {
      // width: 916px;

      // border: 1px solid red;
      padding: 16px 16px 0px 16px;

      //装每条消息的盒子
      .item-Notifications {
        // height: 540px;
        // border: 1px solid blue;
        min-height: 500px;
        //每条消息
        .box-item {
          // margin-top: 16px;
        }

        :deep(.el-button) {
          margin-bottom: 16px;
        }
        
        :deep(.el-table-column--selection){
          // border:1px solid red;
          .cell{
            padding:0px;
            margin:0 auto;
          }
        }
        :deep(.cell)  {
            padding:0px;
            overflow: hidden;
            border: 1px solid transparent;
            border-radius: 8px;
            // justify-content: center;
          }
        

        // .box-item:last-of-type {
        //   margin-bottom: 0px;
        // }
      }

      //////////分页
      .paging {
        // margin: 0 auto;
        display: flex;
        justify-content: center;
        margin-top: 40px;
        margin-bottom: 40px;
        :deep(.el-button.is-plain) {
          margin-left: 24px;
        }
      }
      //最左边的箭头
      :deep(.btn-prev.is-first) {
        margin-right: 12px;
        background-color: #f5f6f7;
      }
      :deep(.btn-next) {
        background-color: #f5f6f7;
      }
      //每个页
      :deep(.number) {
        margin-right: 12px;
        // color:#BBBDBF;
        background-color: #f5f6f7;
      }
      //省略号
      :deep(.more.btn-quicknext.el-icon) {
        margin-right: 12px;
        background-color: #f9f9f9;
      }

      .demo-pagination-block + .demo-pagination-block {
        margin-top: 10px;
      }
      .demo-pagination-block .demonstration {
        margin-bottom: 16px;
      }
    }
  }
}
</style>